module.exports = __webpack_public_path__ + "static/media/9.7a38e95d.png";